import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { TableColumnType, TableRowType, TableType } from '../../../grid/reduxStore/table.types';
import { selectActiveCurrencySettings } from '../../../grid/reduxStore/documentSettingsSlice';
import type { UpdatedTableTotals } from './tableUtils/getUpdatedTableTotals';
import { getUpdatedTableTotalsFromEngine } from './tableUtils/getEngineTableTotals';

export const useTableTotals = () => {
  const currencySettings = useSelector(selectActiveCurrencySettings);

  return useCallback(
    (rows: TableRowType[], columns: TableColumnType[], tableData: TableType): UpdatedTableTotals =>
      getUpdatedTableTotalsFromEngine(rows, columns, tableData, currencySettings),
    [currencySettings]
  );
};
